// extracted by mini-css-extract-plugin
export default {"groupedRow":"groupedRow__3oqHm"};